import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListTicket, updateDataSearch } from "../../actions/Ticket";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { DanhSachTaiSanCombo } from "../../constants/danhSachTaiSanConst";
import StoreApi from "../../service/storeApi";
export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTicket); //dataSearchTaiSan dinh nghia o rootreducer

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);
  useEffect(() => {
    StoreApi.comboAll({}).then((response) => {
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      setdataCombo([
        {
          value: 0,
          label: "Chọn Kho",
        },
        ...dataComboReturn,
      ]);
    });
  }, []);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <input
            placeholder="Tiêu đề"
            type="text"
            className="form-control"
            value={dataSearch.tieude}
            onChange={updateTextValue("tieude")}
          ></input>
        </div>
        <div className="input-sm-new input-new-18 ">
          <button
            type="submit"
            className="btn btn-info-new"
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
